<template>
	<div></div>
</template>

<script>
export default {
	name: 'webchatB',
	data() {
		return {
			loginType: 'wecom',
		}
	},
	methods: {
		sendResult() {
			var search = window.location.search.slice(1)
			if (search) {
				var searchJson = {}
				search.split('&').forEach(item => {
					searchJson[item.split('=')[0]] = item.split('=')[1]
				})
				var postWindow = window.opener
					var token = {}
					if (searchJson.code == 0) {
						// token = JSON.parse(decodeURIComponent(this.staticFunc.getCookie('token')))
					}
				searchJson = Object.assign(searchJson, { token })
				if (postWindow) {
					postWindow.parent.postMessage(searchJson, '*')
				}
			}
		},
	},
	created() {
		this.sendResult()
	},
}
</script>

<style></style>
